import type { StateType } from "../../core/redux/store";
import { sectionDataAdapter } from "./cmsSlice";

// Получаем стандартные селекторы от createEntityAdapter
const cmsSelectors = sectionDataAdapter.getSelectors((state: StateType) => state.cms);

// Селектор для всех CMS
export const selectAllCmsEntities = cmsSelectors.selectAll;

// Селектор по ID
export const selectCmsById = cmsSelectors.selectById;
